import { themeStyle } from '@repo/ui/theming';

export const collapseTheme = {
  arrowColor: themeStyle.varInkMedium,
  hoverBackgroundColor: themeStyle.transparent,
  outerPadding: '16px',
  buttonHeight: '36px',
  fontSize: themeStyle.fontSize16,
};

export const collapseMobileTheme = {
  ...collapseTheme,
  fontSize: themeStyle.fontSize12,
};
